module.exports = __webpack_public_path__ + "img/see-how-low-the-moon-hangs.917c9d3e.png";